import type { IFormData } from '@models/IFormData';
import type { IDataGridService } from '@services/IDataGridService';
import type { IDataTreeService } from '@services/IDataTreeService';
import type { IDictionaryData } from '@models/dictionary/IDictionaryData';
import type { IRouteApprove } from '@models/document/IRouteApprove';
import type { IRouteTraceSource } from '@services/RouteTraceService';

export const documentRemoteFormulaFunctions = [
    'DICTEXIST',
    'GETDATAFROMSP',
    'GETLINKSCOUNT',
    'GETATTACHMENTSCOUNT',
    'OFFSETWORKDAY',
    'LASTWORKDAYAFTEROFFSET',
] as const;

export type DocumentRemoteFormulaFunction = (typeof documentRemoteFormulaFunctions)[number];

export interface IDocumentDataSource {
    readonly supportedFormulaFunctions: ReadonlySet<DocumentRemoteFormulaFunction>;
    readonly linksService?: IDataGridService;
    readonly attachmentsService?: IDataTreeService;
    readonly routesService?: IDataTreeService;
    readonly routeMapService?: IDataGridService;
    readonly eisLogService?: IDataGridService;
    /** Ход маршрута и «Связи» процессов документа; без него окно хода читает основной API поддержки. */
    readonly routeTraceService?: IRouteTraceSource;
    getExternalDataSourceData(sourceName: string, signal?: AbortSignal): Promise<IFormData>;
    getLinksCount(tableKey: string, signal?: AbortSignal): Promise<number>;
    getAttachmentsCount(tableKey: string, signal?: AbortSignal): Promise<number>;
    getRouteApproval?(signal?: AbortSignal): Promise<IRouteApprove>;
    offsetWorkDay?(date: Date, offset: number, signal?: AbortSignal): Promise<string>;
    lastWorkDayAfterOffset?(
        date: Date,
        offset: number,
        allowedWeekDays: number[],
        signal?: AbortSignal,
    ): Promise<string>;
    getDictionaryItem?(
        dictionaryName: string,
        column: string,
        code: string | number | boolean | null | undefined,
        filterType: string,
        signal?: AbortSignal,
    ): Promise<IDictionaryData | null>;
    getStoredProcedureData?(
        procedureName: string,
        params: Record<string, unknown>,
        signal?: AbortSignal,
    ): Promise<Array<Record<string, unknown>>>;
}
